import React from "react";
import { Outlet } from "react-router-dom";

import { useT } from "../i18n";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout() {
  const { t } = useT();

  return (
    <div className="min-h-screen flex flex-col">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:m-3 focus:px-3 focus:py-2 focus:bg-page focus:border focus:border-rule focus:rounded"
      >
        {t("nav.skipToContent")}
      </a>
      <Header />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
